import React from 'react';
import { painPoints } from '../data/painPoints';
export function PainSection() {
  return <section className="bg-navy py-5 sm:py-8" data-id="element-135" data-mp="38yggibtmasnx">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-136" data-mp="38x5cqc069kwt">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-137" data-mp="2uyoxfwo8um32">
          Does this sound <span className="text-electric" data-id="element-138" data-mp="2yz7lrgqxha0i">familiar?</span>
        </h2>
        <div className="mx-auto mt-2 max-w-3xl space-y-1.5 text-center text-sm font-medium leading-snug text-steel sm:text-base" data-id="element-139" data-mp="2l8cci3cioqwe">
          <p data-id="element-140" data-mp="2pzc7v45zn0ws">
            You know how appliances work—but when one symptom could have several
            possible causes, finding the actual fault can quickly become frustrating.
          </p>
          <p data-id="element-141" data-mp="2g8pw5l1e6ujd">
            If you're an appliance repair technician, service technician, independent
            repairer, maintenance technician, or appliance repair trainee, you've
            probably experienced at least one of these situations:
          </p>
        </div>

        <div className="mt-3.5 grid gap-2.5 md:grid-cols-2" data-id="element-142" data-mp="3rn0svhkbgo5l">
          {painPoints.map(point => <article key={point.title} className="flex flex-col rounded-lg border-l-4 border-electric bg-navydeep p-3.5 sm:p-4" data-id="element-143" data-mp="3nlpd03r8vhal">
              <h3 className="text-[15px] leading-tight text-white sm:text-lg" data-id="element-144" data-mp="5dq4wgakpqev">{point.title}</h3>
              <div className="mt-1.5 space-y-1 text-sm leading-snug text-steel" data-id="element-145" data-mp="hj04qtwykyi">
                {point.paragraphs.map(paragraph => <p key={paragraph} data-id="element-146" data-mp="33xpxkflqjlyu">{paragraph}</p>)}
              </div>
              {point.emphasis && <p className="mt-auto pt-2 text-sm font-bold leading-snug text-electric" data-id="element-147" data-mp="3ine0tmdh8up7">
                  {point.emphasis}
                </p>}
            </article>)}
        </div>
      </div>
    </section>;
}